import { GridLegacy as Grid } from '@mui/material';
import { Section } from '@rumblefish/ui/Rumblefish23Theme';

import { industriesWePowerData } from './IndustriesWePower.data';
import type { HeroProps } from './IndustriesWePower.types';
import {
  StyledStack,
  StyledTwoTitles,
  StyledFirstTitle,
  StyledSecondTitle,
  StyledServiceItem,
  StyledServiceIcon,
  StyledServiceIconWrapper,
  StyledServiceIconBackground,
  StyledServiceTitle,
  StyledServiceDescription,
  StyledServiceList,
} from './styles';

export const IndustriesWePower = ({ ...props }: HeroProps) => {
  return (
    <Section width="small">
      <StyledStack {...props}>
        <StyledTwoTitles>
          <StyledFirstTitle variant="display_sm">
            {industriesWePowerData.mainText}
          </StyledFirstTitle>
          <StyledSecondTitle variant="regular_500">
            {industriesWePowerData.description}
          </StyledSecondTitle>
        </StyledTwoTitles>
        <Grid container columnSpacing={{ sm: 8 }} rowSpacing={{ xs: 6, sm: 8 }}>
          {industriesWePowerData.services.map((data, index) => (
            <StyledServiceItem key={index} item xs={12} md={6}>
              <div>
                <StyledServiceIconWrapper>
                  <StyledServiceIconBackground>
                    <StyledServiceIcon src={data.img} alt={data.title} />
                  </StyledServiceIconBackground>
                </StyledServiceIconWrapper>
              </div>
              <div>
                <StyledServiceTitle variant="strong_400">
                  {data.title}
                </StyledServiceTitle>
                <br />
                <StyledServiceDescription variant="regular_300">
                  {data.description}
                </StyledServiceDescription>
                {data?.list && (
                  <StyledServiceList>
                    {data.list.map((item, idx) => (
                      <li key={idx}>{item}</li>
                    ))}
                  </StyledServiceList>
                )}
              </div>
            </StyledServiceItem>
          ))}
        </Grid>
      </StyledStack>
    </Section>
  );
};
